/**
 * Created by iamso on 15.01.2020.
 */

const AllDoneWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            title: Messages.get(connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB) ? "AllDoneWindow.title.complete" : "AllDoneWindow.title"),
            name: "alldonewindow",
            content: this.getContent(),
            button: {
                width: cleverapps.styles.AllDoneWindow.button.width,
                height: cleverapps.styles.AllDoneWindow.button.height,
                text: Messages.get("Play"),
                onPressed: function () {
                    this.close();

                    cleverapps.focusManager.display({
                        stack: true,
                        focus: "PlayButton",
                        action: function (f) {
                            Level.WantsToPlay(f);
                        }
                    });
                }.bind(this)
            }
        });

        AllDoneWindow.showed = true;
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    getContent: function () {
        const styles = cleverapps.styles.AllDoneWindow;
        const elements = [this.getAnimation(), this.getText()].filter(Boolean);

        return new cleverapps.Layout(elements, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getAnimation: function () {
        const animation = bundles.all_done_window && bundles.all_done_window.jsons.all_done_window_json;
        if (animation) {
            const spine = new cleverapps.Spine(animation);
            spine.setAnimation(0, "animation", true);
            return spine;
        }
    },

    getText: function () {
        const styles = cleverapps.styles.AllDoneWindow;

        const messageKey = connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB) ? "AllDoneWindow.text.complete" : "AllDoneWindow.text";
        const text = cleverapps.UI.generateOnlyText(Messages.get(messageKey), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);

        return text;
    },

    listBundles: function () {
        return ["all_done_window"];
    }
});

cleverapps.styles.AllDoneWindow = {
    margin: 20,
    text: {
        width: 753,
        height: 400
    },

    button: {
        width: 300,
        height: 100
    }
};
